module.exports = __webpack_public_path__ + "img/infraicon1.8fcaf157.svg";